<header class="page-header">
  <div class="page-header__inner">
    <h1 class="sr-only">Best Egg</h1>
    <div class="be-logo-v2-container">
      <app-be-logo-v2 [isLink]="true"></app-be-logo-v2>
    </div>
    <div class="right-group">
      <button (click)="logOut()" class="befh-btn befh-btn--outline">
        Log out
      </button>
    </div>
  </div>
</header>
